import { render, staticRenderFns } from "./detailChangeTable.vue?vue&type=template&id=b2662c92&scoped=true&"
import script from "./detailChangeTable.vue?vue&type=script&lang=js&"
export * from "./detailChangeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2662c92",
  null
  
)

export default component.exports